export enum SocketPath {
  UserDetails = 'userDetails',
  ScanResults = 'scanResults'
}
